import { render, staticRenderFns } from "./PuertasAccesoForm.vue?vue&type=template&id=f265e3d2"
import script from "./PuertasAccesoForm.vue?vue&type=script&lang=js"
export * from "./PuertasAccesoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports